import {
  CalendarDaysIcon,
  CurrencyDollarIcon,
  formatNumber,
  GradientCard,
} from "@";

// Donor stat cards
const Numbers = ({ info }) => {
  return (
    <div className="grid grid-cols-1 gap-4">
      <GradientCard
        number={formatNumber(info?.donationAmount)}
        title="اجمالي التبرعات"
      >
        <CurrencyDollarIcon className="h-7 w-7 md:h-9 md:w-9" />
      </GradientCard>

      <GradientCard
        number={formatNumber(info?.donationCounts)}
        title="عدد التبرعات"
      >
        <CalendarDaysIcon className="h-7 w-7 md:h-9 md:w-9" />
      </GradientCard>
    </div>
  );
};

export default Numbers;
